module.exports = __webpack_public_path__ + "static/jordi_serra-479da97a270628cfa9114376d18eb007.jpg";